import { z } from 'zod';

import { ContractType, EmployeeHiringSource, EmployeeStatus, JobHistoryLevel } from '@/common/graphql';

export const EmployeeGeneralInformation = z.object({
  id: z.string().default(''),
  preferredFullName: z.string().default(''),
  legalFullName: z.string().default(''),
  nameInLocalLanguage: z.string().nullable().default(null),
  japanesePhoneticName: z.string().nullable().default(null),
  pictureUrl: z.string().nullable().default(null),
  employeeId: z.string().nullable().default(null),
  employeeCode: z.string().nullable().default(null),
  effectiveDateUntil: z.string().nullable().default(null),
  status: z.nativeEnum(EmployeeStatus).nullable().default(null),
  email: z.string().nullable().default(null),
  hiredDate: z.string().nullable().default(null),
  contractType: z.nativeEnum(ContractType).nullable().default(null),
  contractEndDate: z.string().nullable().default(null),
  officeLocation: z.string().nullable().default(''),
  company: z.string().nullable().default(''),
  companyId: z.string().nullable().default(''),
  companyCountryId: z.string().nullable().default(''),
  businessUnit: z.string().nullable().default(''),
  businessUnitId: z.string().nullable().default(''),
  department: z.string().nullable().default(''),
  departmentId: z.string().nullable().default(''),
  job: z.string().nullable().default(''),
  jobId: z.string().nullable().default(''),
  jobTitle: z.string().nullable().default(''),
  team: z.string().nullable().default(''),
  level: z.nativeEnum(JobHistoryLevel).nullable().default(null),
  companyEmailAccount: z.string().nullable().default(null),
  companyEmailDomain: z.string().nullable().default(null),
  emailAddress: z.string().nullable().default(null),
  primaryManagerId: z.string().nullable().default(''),
  primaryManager: z.string().nullable().default(''),
  dottedLineManagerId: z.string().nullable().default(''),
  dottedLineManager: z.string().nullable().default(''),
  nationalityId: z.string().nullable().default(''),
  nationality: z.string().nullable().default(''),
  location: z.string().nullable().default(''),
  hiringSource: z.nativeEnum(EmployeeHiringSource).nullable().default(null),
  needsProbationReview: z.boolean().default(false),
  probationReviewEndDate: z.string().nullable().default(''),
  isNewGraduate: z.boolean().default(false),
  lastWorkingDate: z.string().nullable().default(null),
  terminationDate: z.string().nullable().default(null),
  reasonForLeaving: z.string().nullable().default(null),
  greenhouseLink: z.string().nullable().default(null),
});
export type EmployeeGeneralInformationType = z.infer<typeof EmployeeGeneralInformation>;
